import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { BytesPipeModule } from 'src/app/pipes/bytes-pipe/bytes-pipe.module';
import { FileUploadComponent } from './file-upload.component';

@NgModule({
   declarations: [FileUploadComponent],
   exports: [FileUploadComponent],
   imports: [
      CommonModule,
      FormsModule,
      MatFormFieldModule,
      MatInputModule,
      ReactiveFormsModule,
      MatIconModule,
      MatButtonModule,
      BytesPipeModule,
   ],
})
export class FileUploadModule {}
